var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLanguages = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 80 80"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 20182"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 20181"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 13758"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 13744",
  transform: "translate(-152.7 -152.88)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 40,
  cy: 40,
  r: 40,
  fill: "none",
  "data-name": "Ellipse 1389",
  transform: "translate(152.7 152.88)"
}))), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  "data-name": "Group 13760"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 12132"
}, /*#__PURE__*/React.createElement("path", {
  d: "M49.477 24.182H30.525a6.276 6.276 0 0 0-6.277 6.276v13.26a6.276 6.276 0 0 0 6.277 6.276h4.71L40 55.819l4.765-5.825h4.711a6.275 6.275 0 0 0 6.276-6.276v-13.26a6.275 6.275 0 0 0-6.275-6.276",
  "data-name": "Path 6075"
}), /*#__PURE__*/React.createElement("path", {
  d: "M36.388 38.731h7.452",
  "data-name": "Line 689"
})), /*#__PURE__*/React.createElement("path", {
  d: "m33.062 42.807 6.935-11.72 6.9 11.72",
  "data-name": "Path 6076"
}))))));
export { SvgLanguages as ReactComponent };
export default __webpack_public_path__ + "static/media/languages.d2a7e8bcd3e4df2c6f2de0a5dc0b4010.svg";